import type { IconSvgObject } from './types';

const FileLockedIcon: IconSvgObject = [
  ["path", { d: "M20 12V9L13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 2V7C13 8.10457 13.8954 9 15 9H20", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.75 17V15.75C14.75 14.7835 15.5335 14 16.5 14C17.4665 14 18.25 14.7835 18.25 15.75V17M13 17V22H20V17H13Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FileLockedIcon;
